import { extend, localize, setInteractionMode } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { isValidNumber } from "libphonenumber-js";
import tr from "vee-validate/dist/locale/tr";
import en from "vee-validate/dist/locale/en";
import { i18n } from "@/plugins/i18n";
import { storageManager } from "../plugins/storage-manager";

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule]
  });
});

extend("integer", {
  ...rules.integer,
  message: (_, values) => {
    return i18n.t("validations.messages.integer", values);
  }
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: (_, values) => {
    return i18n.t("validations.messages.password_math", values);
  }
});

extend("phone", {
  validate(value) {
    return isValidNumber(value);
  },
  message: (_, values) => {
    return i18n.t("validations.messages.phone", values);
  }
});

extend("date", {
  validate(value) {
    return !isNaN(new Date(value).getDate());
  },
  message: (_, values) => {
    return i18n.t("validations.messages.date", values);
  }
});

localize({
  en,
  tr
});

setInteractionMode("passive");

localize(
  storageManager.get("user")
    ? JSON.parse(storageManager.get("user")).language
    : process.env.VUE_APP_I18N_FALLBACK_LOCALE
);
